import Vue from "vue";
import "./styles";
import "./directive/drag";
import "./directive/divdrag";
import "./directive/loadMore";
import "./directive/newDiaLog";
import "./directive/preventReClick";
import elementUI from "element-ui"; // 推荐使用版本2.13.0*
import App from "./App.vue";
import globalParams from "./utils/globalParams";
// 特殊组件
import "@/CommonDP/utils/vue-component/index.js";
import "@/CommonDP/utils/vue-clipboard2/index.js";
window.Vue = Vue;
Vue.use(elementUI);

import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);

import routerInit from "./router";

import request from "@/CommonDP/utils/request";
Vue.prototype.$request = request;
Vue.prototype.$success = (msg) =>
  Vue.prototype.$message({
    showClose: true,
    message: msg,
    type: "success"
  });

Vue.prototype.$warn = (msg) =>
  Vue.prototype.$message({
    showClose: true,
    message: msg,
    type: "warning"
  });

Vue.prototype.$error = (msg) =>
  Vue.prototype.$message({
    showClose: true,
    message: msg,
    type: "error"
  });
import siteInit from "./siteInit";
export { beforePrjId } from "@/CommonDP/store/projectMg.js";

import config from "../../package";
Vue.prototype.$Config = config;

import permissionConst from "./utils/permission-const";
Vue.prototype.$allPerms = permissionConst;

import defaultTitles from "./defaultTitles";

import env from "@/CommonDP/utils/env";
Vue.prototype.$env = env;

export default class CommonDP {
  constructor(options) {
    document.title = options.appTitle || "协同宝-建研宏图协同宝云平台";
    Vue.prototype.$appTitle = options.appTitle || "协同宝-建研宏图协同宝云平台";
    Vue.prototype.$defaultLogo = require("@/CommonDP/assets/logo.png");
    Vue.prototype.$defaultHeadLogo = require("@/CommonDP/assets/组20 1.png");
    Vue.prototype.$appLogo = options.appLogo || Vue.prototype.$defaultLogo;
    Vue.prototype.$collapseLogo = options.collapseLogo || options.appLogo || Vue.prototype.$defaultLogo;
    Vue.prototype.$headLogo = options.headLogo || Vue.prototype.$defaultHeadLogo;
    Vue.prototype.$showLogo = options.showLogo || options.appLogo;
    Vue.prototype.$titles = { ...defaultTitles, ...(options.dynamicTitles || {}) };

    // 扩展或覆盖 Vue.prototype
    Object.assign(Vue.prototype, options.extention || {});

    siteInit.initGlobalParams(options.globalParams || []);

    // 处理自定义路由
    const routeCustomizeFunc = options.routeCustomizeFunc;
    if (routeCustomizeFunc) {
      globalParams.set("fx.routeCustomizeFunc", routeCustomizeFunc);
    }

    // 处理自定义存储
    const storeCustomizeFunc = options.storeCustomizeFunc;
    if (storeCustomizeFunc) {
      globalParams.set("fx.storeCustomizeFunc", storeCustomizeFunc);
    }

    // 处理全局路由守卫
    const beforeEach = options.beforeEach;
    if (beforeEach) {
      globalParams.set("beforeEach", beforeEach);
    }

    // 处理全局路由守卫
    const afterEach = options.afterEach;
    if (afterEach) {
      globalParams.set("afterEach", afterEach);
    }
  }
  async init() {
    // 这里一定要用 require 不能用 import. 因为需要支持自定义配置
    const store = require("./store").default;
    const router = routerInit();
    const vm = new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount("#app");
    require("./VForm/index").default();
    return vm;
  }
}

Vue.component('IconSvg', () => import("@/CommonDP/components/icon-svg/index.vue"));
